import {FC} from 'react'
import {KTSVG} from '../../../helpers'
import {Button} from '../form/Button'
import {useNavigate} from 'react-router-dom'
import {useIntl} from 'react-intl'

type Props = {
  className?: any
  event?: any
  label?: any
}

const ButtonBack: FC<Props> = ({className, event, label}) => {
  const navigate = useNavigate()
  const intl = useIntl()

  const handleBack = () => {
    navigate(-1)
  }

  return (
    <Button
      label={label ?? intl.formatMessage({id: 'BACK'})}
      event={event ?? handleBack}
      className={`${className} btn btn-advanced-tertiary btn-sm fw-bolder me-5`}
      children={<KTSVG path='/media/gori/arrows/arrow_left.svg' />}
    />
  )
}

export {ButtonBack}
